module.exports = __webpack_public_path__ + "img/12.47a5f4c2.png";